<ng-container>
  @if (display('indexFund')) {
    <div class="indexFund">
      <title
        direction="left"
        [style]="{
          'font-size': '16px',
          color: '#3376F6',
          'margin-bottom': '1.5rem',
        }"
      >
        #5 Fonds indiciels (trackers, ETF)
      </title>
      <div class="formControl mt">
        <div class="row">
          <div class="col col-md-12">
            <title
              [style]="{
                fontSize: '16px',
                color: '#2E557A',
                fontWeight: '500',
              }"
              direction="left"
            >
              Ce type d'instrument réplique exactement l'indice sur lequel il
              est adossé.
            </title>
          </div>
          <div class="col col-md-12">
            <pr-input-radio
              formControlName="indexFund1"
              direction="column"
              [isDefault]="false"
              [toggle]="true"
              [options]="options"
              [columns]="3"
            >
            </pr-input-radio>
          </div>
        </div>
        <div class="row">
          <div class="col col-md-12">
            <title
              [style]="{
                fontSize: '16px',
                color: '#2E557A',
                fontWeight: '500',
              }"
              direction="left"
            >
              Je peux acheter ou vendre ce type d'instrument à tout moment de la
              journée, comme une action cotée.
            </title>
          </div>
          <div class="col col-md-12 clear-m">
            <pr-input-radio
              formControlName="indexFund2"
              direction="column"
              [isDefault]="false"
              [toggle]="true"
              [options]="options"
              [columns]="3"
            >
            </pr-input-radio>
          </div>
        </div>
      </div>
    </div>
  }
  @if (display('derivativeProducts')) {
    <div class="derivativeProducts">
      <title
        direction="left"
        [style]="{
          'font-size': '16px',
          color: '#3376F6',
          'margin-bottom': '1.5rem',
        }"
      >
        #6 Produits dérivés (options, futures, warrants, certificats)
      </title>
      <div class="formControl mt">
        <div class="row">
          <div class="col col-md-12">
            <title
              [style]="{
                fontSize: '16px',
                color: '#2E557A',
                fontWeight: '500',
              }"
              direction="left"
            >
              L'utilisation de ce type d'instrument peut augmenter mon risque de
              perte en capital.
            </title>
          </div>
          <div class="col col-md-12 clear-m">
            <pr-input-radio
              formControlName="derivativeProducts1"
              direction="column"
              [isDefault]="false"
              [toggle]="true"
              [options]="options"
              [columns]="3"
            >
            </pr-input-radio>
          </div>
        </div>
        <div class="row">
          <div class="col col-md-12">
            <title
              [style]="{
                fontSize: '16px',
                color: '#2E557A',
                fontWeight: '500',
              }"
              direction="left"
            >
              Il est possible d'utiliser ce type d'instrument pour couvrir un
              risque spécifique dans un portefeuille.
            </title>
          </div>
          <div class="col col-md-12 clear-m">
            <pr-input-radio
              formControlName="derivativeProducts2"
              direction="column"
              [isDefault]="false"
              [toggle]="true"
              [options]="options"
              [columns]="3"
            >
            </pr-input-radio>
          </div>
        </div>
      </div>
    </div>
  }
</ng-container>
